import { z } from 'zod'
import { zIsoDate } from '../common'

// GET /api/v1/admin/health (Bearer) — authenticated liveness + Ads API version.
export const zHealth = z.object({
  status: z.string(),
  app: z.string(),
  time: zIsoDate,
  adsApiVersion: z.string(),
})
export type Health = z.infer<typeof zHealth>
